import { BoxProps, HStack } from '@cardboard-ui/react';
import React from 'react';
import { ItemOptionButtons } from './components/ItemOptionButtons';
import { ItemOptionsMenu } from './components/ItemOptionsMenu';
import { ItemMenu_node$data } from './__generated__/ItemMenu_node.graphql';

export type ItemMenuMode =
  | 'page-bar'
  | 'only-menu'
  | 'item-viewer-bar'
  | 'card'
  | 'list-item'
  | 'grid-item'
  | 'table-item';

export interface ItemMenuProps {
  sx?: BoxProps['sx'];
  node: ItemMenu_node$data;
  mode: ItemMenuMode;
  connectionId?: string;
  isUpdatingPage?: boolean;
  inPinnableContext?: boolean;
  isTaggableContext?: boolean;
  onCompletedDelete?: () => void;
}

export const ItemMenu = (props: ItemMenuProps) => {
  const Component =
    {
      'page-bar': ItemOptionsWithTagsAndChat,
      'only-menu': OnlyMenu,
      'item-viewer-bar': ItemOptionsWithTagsAndChat,
      card: ItemOptionsWithTagsAndChat,
      'list-item': ItemOptionsWithTags,
      'grid-item': DefaultItemOptions,
      'table-item': ItemOptionsWithTags,
    }[props.mode] || ItemOptionsWithTagsAndChat;

  return <Component {...props} />;
};

const ItemOptionsWithTagsAndChat = ({ sx, ...props }: ItemMenuProps) => {
  return (
    <HStack spacing={0} sx={sx}>
      <ItemOptionButtons {...props} showTags showChat />

      <ItemOptionsMenu {...props} />
    </HStack>
  );
};

const DefaultItemOptions = ({ sx, ...props }: ItemMenuProps) => {
  return (
    <HStack spacing={0} sx={sx}>
      <ItemOptionButtons {...props} />
      <ItemOptionsMenu {...props} />
    </HStack>
  );
};

const ItemOptionsWithTags = ({ sx, ...props }: ItemMenuProps) => {
  return (
    <HStack spacing={0} sx={sx}>
      <ItemOptionButtons {...props} showTags />

      <ItemOptionsMenu {...props} />
    </HStack>
  );
};

const OnlyMenu = ({ sx, ...props }: ItemMenuProps) => {
  return (
    <HStack spacing={0} sx={sx}>
      <ItemOptionsMenu {...props} />
    </HStack>
  );
};
